import { useEffect } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft, Sparkle } from "@phosphor-icons/react";
import { t } from "../i18n";
import { fadeUp, stagger } from "../motion";

export default function ComingSoon({ variant }) {
  const s = t.de.soon;
  const data = s[variant] || s.software;

  useEffect(() => { window.scrollTo(0, 0); }, [variant]);

  return (
    <main data-testid="coming-soon" className="min-h-screen bg-navy-900 text-white flex items-center relative overflow-hidden grain">
      <div className="absolute top-1/4 left-1/4 w-[35rem] h-[35rem] bg-gold-500/10 rounded-full blur-3xl" />
      <div className="absolute bottom-0 right-0 w-[30rem] h-[30rem] bg-gold-500/5 rounded-full blur-3xl" />

      <div className="container mx-auto px-6 md:px-12 max-w-3xl relative text-center py-40">
        <motion.div variants={stagger} initial="hidden" animate="show">
          <motion.div variants={fadeUp} className="inline-flex items-center gap-2 px-5 py-2 rounded-full border border-gold-500/30 bg-gold-500/10 mb-10">
            <Sparkle size={16} weight="fill" className="text-gold-400" />
            <span className="text-xs font-semibold uppercase tracking-[0.25em] text-gold-400">{s.badge}</span>
          </motion.div>

          <motion.h1 variants={fadeUp} className="text-4xl sm:text-5xl lg:text-6xl font-light tracking-tight leading-tight">
            {data.title}
          </motion.h1>
          <motion.p variants={fadeUp} className="mt-6 text-lg md:text-xl text-white/60 max-w-xl mx-auto leading-relaxed">
            {data.d}
          </motion.p>
          <motion.p variants={fadeUp} className="mt-6 text-white/50 max-w-lg mx-auto leading-relaxed">
            {s.text}
          </motion.p>

          <motion.div variants={fadeUp} className="mt-12">
            <Link
              to="/"
              data-testid="soon-back"
              className="group inline-flex items-center gap-2 backdrop-blur-md bg-white/10 border border-white/20 rounded-full px-8 py-4 font-medium transition-all hover:bg-white/20 hover:-translate-y-0.5"
            >
              <ArrowLeft size={18} className="group-hover:-translate-x-1 transition-transform" />
              {s.back}
            </Link>
          </motion.div>
        </motion.div>
      </div>
    </main>
  );
}
